var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'ui-circle-preloader':true, '--secundary': _vm.themeColor },style:(_vm.spinnerStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }